import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { Accordion } from '@components/Accordion';
import {
  getAccordionSx,
  getAccordionHeaderSx,
  getAccordionTitleSx,
  getTestGridPaperSx,
  type StatusConfig
} from '../styles';

type TestAccordionSectionProps = {
  id: string;
  title: string;
  status: StatusConfig;
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
  isDarkMode: boolean;
  statusIndicator: React.ReactNode;
  children: React.ReactNode;
};

export const TestAccordionSection: React.FC<TestAccordionSectionProps> = ({
  id,
  title,
  status,
  expanded,
  onExpandedChange,
  isDarkMode,
  statusIndicator,
  children
}) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Accordion
        title={
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%'
            }}
          >
            <Typography
              variant="h6"
              sx={getAccordionTitleSx(isDarkMode, status)}
            >
              {title}
            </Typography>
            {statusIndicator}
          </Box>
        }
        expanded={expanded}
        onChange={(_, isExpanded) => onExpandedChange(isExpanded)}
        id={id}
        headerSx={getAccordionHeaderSx(isDarkMode, status, expanded)}
        sx={getAccordionSx(isDarkMode, status)}
      >
        <Paper sx={getTestGridPaperSx(isDarkMode)}>{children}</Paper>
      </Accordion>
    </Box>
  );
};
